import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectivityComponent } from './connectivity/connectivity.component';
import { RouterModule, Routes } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { ConnectivityActionDialogComponent } from './connectivity-action-dialog/connectivity-action-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { InvitationListComponent } from './invitation-list/invitation-list.component';
import { NgxLoadingModule } from 'ngx-loading';
import { InvitationActionDialogComponent } from './invitation-action-dialog/invitation-action-dialog.component';
import { KeycloakGuard } from 'app/modules/auth/login/keycloak.guard';

const routes: Routes = [
  { path: '', canActivate: [KeycloakGuard],component: ConnectivityComponent },
  { path: 'invitation-list', canActivate: [KeycloakGuard], component: InvitationListComponent },
]

@NgModule({
  declarations: [
    ConnectivityComponent,
    ConnectivityActionDialogComponent,
    InvitationListComponent,
    InvitationActionDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTabsModule,
    MatSelectModule,
    MatOptionModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatTableModule,
    MatCardModule,
    MatButtonModule,
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
  ],
  exports: [
    RouterModule
  ],
  entryComponents: [ConnectivityActionDialogComponent,InvitationActionDialogComponent]
})
export class ConnectivityModule { }
